import { EndpointUrl } from 'api/endpoint';
import { useFetcher } from 'api/fetcher';
import { useWorkspaceId } from 'api/providers/workspaceProvider';
import { FinsightEntityField } from 'shared';

export function useFieldTypes() {
  return useFetcher<{ type: string; description: string | null }[]>(
    'field-types',
  );
}

export function useField(type: string | null) {
  return useFetcher<FinsightEntityField[]>(type ? `field/${type}` : null);
}

export function useFieldData(type: string | null, name: string | null) {
  return useFetcher<FinsightEntityField[]>(
    type && name ? `field/${type}/${name}` : null,
  );
}

export function useCreateType() {
  const workspaceId = useWorkspaceId();

  return async (type: string, description: string | null) => {
    if (!workspaceId) throw new Error('No workspace selected');
    return await fetch(
      `${EndpointUrl}/workspace/${workspaceId}/entity-types/${type}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-finsight-token': localStorage.getItem('token') || '',
        },
        body: JSON.stringify({
          description,
        }),
      },
    );
  };
}
